import styles from "./popupWithImage.module.css";
import ImgBuilder from "../../assets/ImgBuilder";
import { renderWithLineBreaksAndBold } from '../../functions/renderWithLineBreaksAndBold';

const PopupWithImage = ({img, name, description, button, button_exit, type, content, defContinue, defExit}) => {
  const image = img ?? ImgBuilder.marcusThrone;
  const defExitEdited = defExit ?? defContinue;


  const renderContent = {
    "showId": (content) => (
      <div className={styles.newIdContainer}>
        {content.split("").map((char, index) => (
          <div className={styles.keyId} key={index}>{char}</div>  

        ))}
      </div>
    ),
    "confirmation": (content) => (
      <></>
    ),
    default: (msg, idx) => (
      <></>
    ),
  };

  return (
    <div className={styles.popupWrapper}>
      <div onClick={() => defExitEdited()} className={styles.overlay}></div>

      <div className={styles.popupContainer}>
        <div className={`${styles.popup} ${type==="confirmation" ? styles.popupMultiple : ""}`}>


          <div className={`${styles.upperPopup} ${type==="confirmation" ? styles.upperPopupMessage : ""}`}>
            {!(type==="confirmation") &&
              <img alt="bg popup top" className={styles.upperPopupImage} src={image}/>
            }
            

            <div className={styles.upperPopupTextContainer}>
              <p className={styles.upperPopupText}>
                {name}
              </p>
            </div>

          </div>



          <div className={styles.lowerPopup}>
            {description &&
            <p className={styles.textLowerPopup}>
              {renderWithLineBreaksAndBold(description)}
            </p>
            }

            {renderContent[type]
              ? renderContent[type](content)
              : renderContent.default()
            }
            
            <div className={`${styles.buttonsContainer} ${defExit ? styles.buttonsContainerMultiple: ""}`}>
              
              <button onClick={() => defContinue()} className={`${styles.singleAffirmativePopup} ${defExit ? styles.singleAffirmativePopupRed: ""}`}>
                {button}
              </button>
              {defExit &&
                <button onClick={() => defExit()} className={styles.singleAffirmativePopup}>
                  {button_exit}
                </button>
              }
            </div>
          </div>

        </div>
      </div>

    </div>
  );
};
export default PopupWithImage;

